module.exports = __webpack_public_path__ + "static/media/03_01_02.2b46f4f6.png";